import Cookies from "js-cookie";

import { Winda } from "./Winda";
import { defaultEnabledCookiesItems } from "./constants";

export const marketingAttributionProperties = [
  "rc",
  "ref_code",
  "ref_src",
  "group_code",
  "groupcode",
  "keyword",
  "gclid",
  "msclkid",
  "ad_id",
  "adset_id",
  "campaign_id",
  "adgroup_id",
  "feeditem_id",
  "target_id",
  "loc_physical_ms",
  "loc_interest_ms",
  "matchtype",
  "network",
  "device",
  "creative",
  "placement",
  "_fbp",
  "_fbc",
  "li_fat_id",
] as const;

// we need to be able to get groupcode from the url params but we do not want
//to pass that through to the SSU mutation as it gets transformed to group_code
// Adding it to the abvove array, but filtering in the
// getSavedMarketingAttributionProperties function achieves that

export const getSavedMarketingAttributionProperties = (): {
  [key: string]: string;
} =>
  marketingAttributionProperties
    .filter((param) => param !== "groupcode")
    .reduce(
      (urlParameterValues, urlParameter) => ({
        ...urlParameterValues,
        [urlParameter]: Cookies.get(urlParameter) || undefined,
      }),
      {},
    );

// These are the default rejected cookie items for segment integrations
//segment.com/docs/connections/sources/catalog/libraries/website/javascript/#load-options

export const getCookieCategories = () => {
  const groups = getCookieGroups() || "";
  return {
    strictlyNecessary: !!groups["Functional"],
    securityAndFraud: !!groups["Functional"],
    performance: !!groups["SaleOfInfo"],
    functional: !!groups["Functional"],
    targeting: !!groups["SaleOfInfo"],
    socialMedia: !!groups["SaleOfInfo"],
  };
};

/**
 * Created a helper function to enclose Winda and conditional logic.
 * End result would be a returned cookie groups value that can be reused elsewhere
 */
export const getCookieGroups = () => {
  const groups = Winda.isPresent
    ? window.airgap?.getConsent?.().purposes
    : undefined;
  return groups;
};

export const getSegmentDestinationsFromCookies = () => {
  const groups = getCookieGroups();
  if (!groups) return defaultEnabledCookiesItems;
  const categories = getCookieCategories();

  return {
    Mutiny: categories.functional,
    Amplitude: categories.performance,
    "Amplitude Actions": categories.performance,
    "Amazon S3": categories.strictlyNecessary,
    "Google Tag Manager": categories.performance,
    snowflake: categories.performance,
    Hotjar: categories.performance,
    Statsig: categories.performance,
    /**
     * Defaulted to false, if you want to enable marketo for certain events,
     * explicitly pass in "Marketo V2": true to the identify / track event
     */
    "Marketo V2": false,
  };
};

export const isGeofencingGDPR = () => {
  if (!Winda.isPresent) return true;
  return !!window.airgap?.getRegimes?.().has("GDPR");
};

// Loads scripts for Iovation device fingerprinting
// Iovation provids a script that will load the firstparty (static and dynamic) scripts and thirdparty scripts
export const loadIovation = () => {
  // execute this async to minimize impact on loading of the page
  setTimeout(() => {
    window.io_global_object_name = "IovationGlobal";
    window.iovation_blackbox = "";

    // Iovation global object that gets used by the Iovation script
    window.IovationGlobal = window.IovationGlobal || {
      enable_flash: false,
      // Iovation scripts will call this function when device fingerprinting occurs
      //  bb - blackbox string
      //  complete - whether the full blackbox string is completely generated
      bb_callback: function (bb: string, complete: boolean) {
        if (complete) {
          window.iovation_blackbox = bb;
        }
      },
      loader: {
        uri_hook: "/api/security",
        subkey: "",
        version: "general5",
      },
    };

    // Load the iovation_script
    import("./analytics/iovation");
  });
};
